import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { compName, month } from "../../../../utils/constant";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { useSelector } from "react-redux";
import WidgetNote from "../../WidgetNote";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import moment from "moment";

const AnnSummary = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const yearsArr = [
    ...commonService.getPastYearForDropDown(10),
    ...commonService.getFutureYearForDropDown(10),
    new Date().getFullYear(),
  ]?.sort(function (a, b) {
    return a - b;
  });
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const tableData = [
    { month: "January", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "February", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "March", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "April", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "May", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "June", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "July", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "August", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "September", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "October", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "November", occ: 0, rms: 0, adr: 0, rev: 0 },
    { month: "December", occ: 0, rms: 0, adr: 0, rev: 0 },
  ];
  let occ = 0,
    rms = 0,
    adr = 0,
    rev = 0;
  const [loading, setLoading] = useState(false);
  const [annSummaryData, setAnnSummaryData] = useState(null);
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [widgetModal, setWidgetModal] = useState(false);
  const widgetDetailRef = useRef();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };

  const getAnnSummaryData = async () => {
    setLoading(true);
    let annSummaryResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot + API_URL.CANCELLATION.GET_ANN_SUMMARY,
        body: {
          AsOfDate: para?.asOfDate,
          year: selectedYear,
          propertyCode: para?.propertyCode,
        },
      },
      false
    );

    let response = apiResponse(false, annSummaryResponse);

    if (response?.isValidate) {
      setAnnSummaryData(response?.data?.data);
      setLoading(false);
    }

    if (!response?.isValidate) {
      setAnnSummaryData(tableData);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (api === 0) {
      setAnnSummaryData(tableData);
    } else {
      if (para?.asOfDate) {
        getAnnSummaryData();
      }
    }
  }, [selectedYear, para?.asOfDate]);

  const [tblids, settblids] = useState({
    annSummaryCancellation: commonService.GenerateGUID(),
  });

  return (
    <div className="widget-container" style={{position: "relative"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("AnnSummary", "menuicon", propertyCode)}
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("AnnSummary", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.annSummaryCancellation,
                  "Account",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("AnnSummary", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.annCancellationSummary,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("AnnSummary", "menuicon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.annSummaryCancellation}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.annSummaryCancellation,
                  `${para?.propertyCode}-Account-${moment(new Date()).format(
                    "MMDDYYYY"
                  )}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table">
          <Table id={tblids.annSummaryCancellation} responsive>
            <thead>
              <tr>
                <th colSpan={5} className="text-center">
                  <Row>
                    <Col xl={4}>
                      <Form.Select id={commonService.generateGlobalClickTrackerID("AnnSummary", "annual-cancellation-month", propertyCode)}
                        value={selectedYear}
                        onChange={(e) => {
                          setSelectedYear(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {yearsArr?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      <span style={{ display: "none" }}>{selectedYear}</span>
                    </Col>
                    <Col xl={8}>Annual Cancellation</Col>
                  </Row>
                </th>
              </tr>
              <tr>
                <th>Month</th>
                <th>OCC</th>
                <th className="text-center">RMS</th>
                <th className="text-end">ADR</th>
                <th className="text-end">REV</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : (
                annSummaryData &&
                month?.map((item, index) => {
                  let findMonthData = annSummaryData?.filter(
                    (x) => x.month?.trim() === item
                  );

                  if (findMonthData?.[0]?.occ) {
                    occ = occ + findMonthData?.[0]?.occ;
                  } else {
                    occ = occ + 0;
                  }
                  if (findMonthData?.[0]?.rms) {
                    rms = rms + findMonthData?.[0]?.rms;
                  } else {
                    rms = rms + 0;
                  }
                  if (findMonthData?.[0]?.adr) {
                    adr = adr + findMonthData?.[0]?.adr;
                  } else {
                    adr = adr + 0;
                  }
                  if (findMonthData?.[0]?.rev) {
                    rev = rev + findMonthData?.[0]?.rev;
                  } else {
                    rev = rev + 0;
                  }

                  return (
                    <React.Fragment key={index}>
                      <tr key={index} className="shadowOnHover">
                        <td>{item}</td>
                        <td>
                          {findMonthData?.[0]?.occ
                            ? findMonthData?.[0]?.occ
                            : 0}
                          %
                        </td>
                        <td className="text-center">
                          {findMonthData?.[0]?.rms
                            ? commonService.formateRoom(findMonthData?.[0]?.rms)
                            : 0}
                        </td>
                        <td className="text-end">
                          {findMonthData?.[0]?.adr
                            ? commonService.formateAmount(
                                findMonthData?.[0]?.adr
                              )
                            : commonService.formateAmount(0)}
                        </td>
                        <td
                          className="text-end perbackground perbackground-rev"
                          value={findMonthData?.[0]?.rev}
                        >
                          {findMonthData?.[0]?.rev
                            ? commonService.formateAmount(
                                findMonthData?.[0]?.rev
                              )
                            : commonService.formateAmount(0)}
                        </td>
                      </tr>
                      {index === 11 && (
                        <tr key={index} className="shadowOnHover">
                          <td className="boldTd">Total</td>
                          <td className="boldTd">{parseInt(occ / 12)}%</td>
                          <td className="boldTd text-center">{commonService.formateRoom(rms)}</td>
                          <td className="boldTd text-end">
                            {rev !== 0 && rms !== 0
                              ? commonService.formateAmount(parseInt(rev / rms))
                              : commonService.formateAmount(0)}
                          </td>
                          <td className="boldTd text-end">
                            {commonService.formateAmount(rev)}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {api !== 0 && <Comments widgetDetails={para} editorId={"AnnSummary"} />}

      {/* {showNoteSidebar && (
        <WidgetNote
          show={showNoteSidebar}
          handleClose={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )} */}
      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default AnnSummary;
